import {
  BulkUploadReceivedInvoicesRequest,
  ImportApCurrencyRatesBody,
  ProcessOcrInvoiceInferencesBody,
} from '../../openapi/model';
import { BulkUploadBusinessDocumentsRequest } from '../../openapi/model/bulkUploadBusinessDocumentsRequest';
import {
  CustomUpdateReportRequest,
  convertRequestBodyToFormData,
} from './requests/update_report_form_request';

const isBulkUploadFormRequest = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any
): body is BulkUploadBusinessDocumentsRequest => {
  return (
    'files' in body &&
    'do_ai_ocr' in body &&
    'document_type' in body &&
    'receipt_type' in body
  );
};

const isBulkUploadReceivedInvoicesRequest = (
  body: unknown
): body is BulkUploadReceivedInvoicesRequest => {
  if (typeof body !== 'object' || body === null) {
    return false;
  }

  return ['files', 'pic_ids', 'receipt_type', 'ap_payee_id'].every(
    (key) => key in body
  );
};

const isUpdateReportFormRequest = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any
): body is CustomUpdateReportRequest => {
  return 'report' in body;
};
const isSingleFileFormRequest = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any
): body is ImportApCurrencyRatesBody => {
  return 'file' in body;
};

const isProcessOcrInvoiceInferencesRequest = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any
): body is ProcessOcrInvoiceInferencesBody => {
  return 'invoice_id' in body && 'file' in body;
};

export const customFomDataFn = <Body>(body: Body): FormData => {
  const formData = new FormData();

  if (isBulkUploadFormRequest(body)) {
    if (body.files.length > 0) {
      body.files.forEach((value, idx) =>
        formData.append(`files[${idx}]`, value)
      );
    }

    formData.append('do_ai_ocr', body.do_ai_ocr.toString());
    formData.append('document_type', body.document_type);
    formData.append('receipt_type', body.receipt_type);
  } else if (isProcessOcrInvoiceInferencesRequest(body)) {
    if (body.invoice_id) {
      formData.append('invoice_id', body.invoice_id);
    }
    if (body.file) {
      formData.append('file', body.file);
    }
    if (body.is_used_ai_suggestion !== undefined) {
      formData.append(
        'is_used_ai_suggestion',
        body.is_used_ai_suggestion.toString()
      );
    }
  } else if (isSingleFileFormRequest(body)) {
    if (body.file) {
      formData.append('file', body.file);
    }
    // ImportInvoiceReportsRequest: proxy import 用の target_office_member_id
    if (
      'target_office_member_id' in body &&
      body.target_office_member_id != null &&
      body.target_office_member_id !== ''
    ) {
      formData.append(
        'target_office_member_id',
        String(body.target_office_member_id)
      );
    }
  } else if (isBulkUploadReceivedInvoicesRequest(body)) {
    if (body.files.length > 0) {
      body.files.forEach((value, idx) => {
        if (value.file) {
          formData.append(`files[${idx}][file]`, value.file);
        }
        if (value.do_ai_ocr !== undefined) {
          formData.append(
            `files[${idx}][do_ai_ocr]`,
            value.do_ai_ocr.toString()
          );
        }
      });
    }

    body.pic_ids?.forEach((value) => {
      formData.append(`pic_ids[]`, value);
    });

    formData.append('ap_payee_id', body.ap_payee_id ?? '');

    formData.append('receipt_type', body.receipt_type);
  }
  if (isUpdateReportFormRequest(body)) {
    convertRequestBodyToFormData(body, formData);
  }

  return formData;
};
